import { SegmentsIcon } from 'canoe';

export const SEGMENTS_ROUTE = {
  key: 'Segments',
  name: 'Segments',
  path: 'segments',
  icon: SegmentsIcon,
};
